import React, { useState } from "react";
import "./feedback-modal.css";
import { IoClose } from "react-icons/io5";
import './otp-code-modal.css';
import { Copy } from "lucide-react";
import { showToast } from "../toasts/ToastNotification";

const OtpCodeModal = ({ isOpen, onClose, otp }) => {
  if (!isOpen) return null;

  const copyToClipboard = (text) => {
      showToast("Copy OTP thành công", "success");
    navigator.clipboard.writeText(text);
    onClose();
    };

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal">
        <div className="modal-header">
          <h2 className="otp-title">Lấy OTP thành công</h2>
          <button className="feedback-modal-close-btn" onClick={onClose}>
            <IoClose />
          </button>
        </div>
        <div className="otp-modal-container">
          <p className="otp-message">Mã OTP của bạn là:</p>
          <div className="otp-copy-container">
            <p className="otp-code">{otp}</p>
            <Copy onClick={() => copyToClipboard(otp)} className="otp-copy-icon"></Copy>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpCodeModal;
